import printerIcon from "./printer_icon_23px_light.png";

export const PrinterIcon = () => <img src={printerIcon} alt="printer" />;